<template>
  <div>
    <v-container>
      <h1>Policy</h1>
      <v-row>
        <v-col md="4" sm="6" xs="12">
          <!-- <v-text-field
            v-model="model.deadlineReminders"
            type="number"
            label="Deadline Reminders"
          ></v-text-field> -->
          <v-checkbox
            label="Deadline Reminders"
            v-model="model.deadlineReminders"
          ></v-checkbox>
        </v-col>
        <v-col md="4" sm="6" xs="12">
          <v-checkbox
            label="Requires Approval"
            v-model="model.requiresApproval"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click.stop="update" color="success" :loading="loading"
            >Update</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import isEmpty from "lodash/isEmpty";
export default {
  data: () => ({
    model: {},
    loading: false,
  }),
  methods: {
    update() {
      this.loading = true;
      this.$axios
        .post(`/api/onboardingPolicy`, this.model)
        .then(({ data }) => {
          this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPolicy() {
      this.$axios
        .get(`/api/onboardingPolicy`)
        .then(({ data }) => {
          if (!isEmpty(data)) this.model = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
  },
  created() {
    this.getPolicy();
  },
};
</script>
